<template>
  <v-container id="plan" class="pa-0">
    <div>
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title">{{ $t('계획제출') }}</v-col>
        <v-col cols="12" class="pt-0 px-6 pb-4">
          <!-- 가능일수  -->
          <v-chip label class="chip-desc" color="#E8F9ED"
            ><span>{{ $t('연차 사용 기간') }} {{ planPeriod }}</span></v-chip
          >
        </v-col>
      </v-row>
      <div class="overflow-y-auto" :style="scrollViewStyle">
        <!-- 반복 단위 시작 -->
        <annual-plan-item
          v-for="(plan, index) in planList"
          :key="index"
          :index="index"
          :planObj="plan"
        />

        <!-- 반복 단위 끝 -->
      </div>
      <!-- empty Data component -->
      <no-applicable
        v-if="emptyDataFlag"
        :text="emptyDataText"
        :toMainBtn="true"
      />
    </div>
  </v-container>
</template>
<script>
import AnnualPlanItem from '@/components/application/annualPlan/AnnualPlanItem.vue';
import NoApplicable from '@/components/common/NoApplicable.vue';

import { getCodeNm } from '@/utils/common/codeUtil';
import { getAnnualPlanYearList, getAnnualPlanList } from '@/api/annualPlan';
import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      emptyDataFlag: false,
      emptyDataText: '',

      yearData: {},
      planList: [
        {
          date: '',
          codeObj: { code: '', codeNm: '' },
          holDay: 0, // 전체일수
          closeDay: 0, // 적용일수
          saved: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_LIST']),
    // 연차사용기간
    planPeriod() {
      return ` ${dayjs(this.yearData.useSYmd).format('YYYY-MM-DD')} ~
              ${dayjs(this.yearData.useEYmd).format('YYYY-MM-DD')}`;
    },
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_BTN
      }px`;
    },
  },
  methods: {
    /* 년도 목록 조회 */
    async fetchAnnualPlanYearList() {
      try {
        const response = await getAnnualPlanYearList({
          searchSabun: this.GET_USER_DATA.ssnSabun,
        });
        const yearList = response.data.data;
        const curYear = dayjs().year().toString();

        // 현재년도 데이터
        const curYearDataList = yearList.filter(obj => obj.year === curYear);

        if (curYearDataList.length > 1) {
          // 현재 년도 2개 이상일때
          this.emptyDataText = '웹에서 연차사용계획을 확인 해주세요.';
          this.emptyDataFlag = true;
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        } else if (curYearDataList.length === 1) {
          this.yearData = curYearDataList[0];

          // 계획 제출 전일 때
          if (this.yearData.closeYn === 'N') {
            this.$router.push(routerNames.AnnualPlanWrite);
          } else {
            this.fetchAnnualPlanList();
          }
        }
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
      }
    },

    /* 연차사용계획작성 목록 조회 */
    async fetchAnnualPlanList() {
      try {
        const { data } = await getAnnualPlanList({
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchUseSYmd: this.yearData.useSYmd,
          searchUseEYmd: this.yearData.useEYmd,
          searchGubun: this.yearData.gubun,
          editYn: 'N',
        });

        const planList = data.data.filter(obj => obj.line === 'B');
        if (planList.length > 0) {
          // 앱에서 저장된 데이터 있을때
          this.planList = [];
          planList.forEach(element => {
            this.planList.push({
              sYmd: dayjs(element.sYmd).format('YYYY-MM-DD'),
              eYmd: dayjs(element.eYmd).format('YYYY-MM-DD'),
              codeObj: {
                code: element.gntCd,
                codeNm: getCodeNm(this.GET_GNT_CD_LIST, element.gntCd),
              },
              holDay: element.holDay,
              closeDay: element.closeDay,
              btnApp: element.btnApp,
              saved: true,
            });
          });
        } else {
          alert('잘못된 접근입니다.');
        }

        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
      }
    },

    /* 근태코드 조회 */
    async fetchGntCd() {
      await this.$store.dispatch('CODE/FETCH_GNT_CD', {
        cmd: 'gntCdApp',
        searchGntGubunCd: 1,
      });
    },
  },
  created() {
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchGntCd();
    this.fetchAnnualPlanYearList();
  },
  components: {
    // IconWorkDay,
    AnnualPlanItem,
    NoApplicable,
  },
};
</script>
<style scoped>
/* annualPlan.scss 참고 */
</style>
